export const logs = {
  createdBlock: 'Block created',
  deletedBlock: 'Block deleted',
  blockChanged: 'Block parameter changed',
  movedBlock: 'Block moved',
  blockDrag: 'Block dragged',
  variableCreated: 'Variable created',
  variableDeleted: 'Variable deleted',
  variableRenamed: 'Variable renamed',
  commentCreated: 'Comment added',
  commentDeleted: 'Comment deleted',
  commentChanged: 'Comment content changed',
  commentMoved: 'Comment moved',
  uiAction: 'UI action',
  elementSelected: 'Element selected',
  elementClicked: 'Element clicked',
  viewportChanged: 'Workspace view changed',
  trashcanChanged: 'Trashcan state changed',
  toolboxItemSelected: 'Toolbox category changed',
  themeChanged: 'Theme changed',
  finishedLoading: 'Project loading finished',
  other: 'Other unspecified operation',
}
